import React from 'react';
import './Testimonials.css';
import AVATAR1 from '../../assets/avatar-chris.jpg';
import AVATAR2 from '../../assets/avatar-matheus.jpeg';
import AVATAR3 from '../../assets/avatar-marina.jpg';
// import AVATAR4 from '../../assets/avatar-gringo.jpg';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

const Testimonials = ({ t }) => {
  return (
    <section id='testimonials'>
      <h5>{t("feedback-title")}</h5>
      <h2>{t("feedback-subtitle")}</h2>
      <div className="testmonial__cards">
      <Swiper className="container testimonials__container"
        slidesPerView={2}
        spaceBetween={30}
        setWrapperSize={ true }
        centeredSlides={ true }
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        modules={[Pagination]}
      >
              {/* 4 TIMES */}
        <SwiperSlide className="testimonial">
          <div className="clients__avatar">
            <img 
              className="avatar"
              src={ AVATAR2 } 
              alt={t("feedback-card2-image-alt")} 
            />
          </div>
          <h5 className="client__name">
              <a href="https://www.linkedin.com/in/matheus-beaumord/" target="_blank" rel="noopener noreferrer" >
              {t("feedback-card2-name")}
              </a>
            </h5>
            <small className="client__review">
              {t("feedback-card2-text")}
            </small>
        </SwiperSlide>
        <SwiperSlide className="testimonial">
          <div className="clients__avatar">
            <img  
              className="avatar"
              src={ AVATAR3 } 
              alt={t("feedback-card3-image-alt")} 
            />
          </div>
            <h5 className="client__name">
              <a href="https://www.linkedin.com/in/marina-darcie-948bb0120/" target="_blank" rel="noopener noreferrer" >
              {t("feedback-card3-name")}
              </a>
            </h5>
            <small className="client__review">
              {t("feedback-card3-text")}
            </small>
        </SwiperSlide>
          <SwiperSlide className="testimonial">
            <div className="clients__avatar">
              <img 
                className="avatar"
                src={ AVATAR1 } 
                alt={t("feedback-card1-image-alt")} 
              />
            </div>
            <h5 className="client__name">
              <a href="https://www.linkedin.com/in/christiano-barsante/" target="_blank" rel="noopener noreferrer" >
              {t("feedback-card1-name")}
              </a>
            </h5>
            <small className="client__review">
              {t("feedback-card1-text")}
            </small>
        </SwiperSlide>
        {/* <SwiperSlide className="testimonial">
          <div className="clients__avatar">
            <img  
              className="avatar
              "src={ AVATAR4 } 
              alt={t("feedback-card4-image-alt")} 
            />
          </div>
            <h5 className="client__name">
              <a href="https://www.linkedin.com/in/luizhenriquebueno/" target="_blank" rel="noopener noreferrer" >
              {t("feedback-card4-name")}
              </a>
            </h5>
            <small className="client__review">
              {t("feedback-card4-text")}
            </small>
        </SwiperSlide> */}

      </Swiper>
      </div>
    </section>
  )
}

export default Testimonials;
